import AddArticle from "../../../components/admin/articles/AddArticle";
import Admin from "../../Admin";

const ArticleAdd = () => {
    return ( 
        <Admin>
            <AddArticle/>
        </Admin>
     );
}
 
export default ArticleAdd;